import { render } from "./ProductType.vue?vue&type=template&id=4111bf1d&ts=true"
import script from "./ProductType.vue?vue&type=script&lang=ts"
export * from "./ProductType.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__